__turbopack_context__.v({
  "greenDot": "AboutSuccessSection-module__lK5ZEq__greenDot",
  "iconCircle": "AboutSuccessSection-module__lK5ZEq__iconCircle",
  "iconSmall": "AboutSuccessSection-module__lK5ZEq__iconSmall",
  "sectionSpace": "AboutSuccessSection-module__lK5ZEq__sectionSpace",
});
